<template>
  <div
      v-loading="boxLoading"
      class="pdf-preview-out"
    >
      <!-- 上部 外层容器 用于滚动-->
      <div class="scroll-box">
        <!-- 用于截取调缩放后的空白区域 -->
        <div class="pdf-box">
          <!-- pdf预览区域(会被缩放) -->
          <div
            class="pdf-scale-box"
          >
            <!-- 预览组件 -->
            <pdf
              :src="url"
              :page="currentPage"
              @num-pages="getTotalPage"
              @loaded="mountedLoaded"
            />
          </div>
        </div>
      </div>

      <!-- 底部操作栏 -->
      <div class="bottom-tools">
        <div>
          共 {{ pageTotal }} 页
        </div>
        <div class="page">
          <el-button
            round
            type="primary"
            :disabled="currentPage === 1"
            @click="chengPage"
          >
            上一页
          </el-button>
          <!-- 页码展示及跳转 -->
          <el-button
            round
            type="primary"
            :disabled="currentPage === pageTotal"
            @click="chengPage('+')"
          >
            下一页
          </el-button>
        </div>
      </div>
    </div>
</template>

<script>
// 插件引入
import pdf from 'vue-pdf'
export default {
  components: {
    pdf
  },
  props: {
    // pdf预览的地址 由父组件中传入 也可在本组件中直接赋值
    url: {
      type: String,
      default: ''
    },
    currentPage: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      // 总页数
      pageTotal: 0,
      // 缩放比例
      pageScale: 0.8,
      // 遮罩
      boxLoading: true,
      pageChangeTimer: null
    }
  },
  methods: {
    // 获取到pdf总页数时触发 会传入总页数
    getTotalPage(page) {
      this.pageTotal = page
    },
    // 初始化加载完毕触发
    mountedLoaded() {
      // 去除遮罩
      this.boxLoading = false
    },
    // 设置pdf预览区域容器的缩放尺寸
    getPdfSize() {
      return {
        transform: `scale(${this.pageScale})`
      }
    },
    // 方法 翻页
    chengPage(type) {
      // 防抖 0.5秒内不再次触发时执行
      if (this.pageChangeTimer) {
        clearTimeout(this.pageChangeTimer)
      }
      // 执行翻页
      this.pageChangeTimer = setTimeout(() => {
        if (type === '+') {
          this.$emit('changeadd', 1)
          // this.currentPage += 1
        } else {
          this.$emit('changecont', 1)
          // this.currentPage -= 1
        }
        // 翻页后将滚动条归位到顶部
        this.scrollbarReset()
        this.pageChangeTimer = null
      }, 500)
    },
    // 方法 滚动条归位到顶部
    scrollbarReset() {
      const boxDom = document.querySelector('.scroll-box')
      boxDom.scrollTop = 0
    }
  }
}
</script>

<style lang="less" scoped>
.pdf-preview-out {
  // 高度为占满父组件中的外层容器(若不需要在父组件中设置高度 也可以在本组件中直接设置为所需值)
  height: 100%;
  // border: 1px solid #909;
  &, div {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  // 滚动容器
  .scroll-box {
    // 高度按比例 溢出滚动
    height: calc(100% - 50px);
    overflow: auto;
    border: 2px solid #c0d8f3;
    border-bottom: none;
    border-radius: 6px;
    background-color: #eeeeee;
    // 滚动条样式
    &::-webkit-scrollbar {
      width: 10px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #c0d8f3;
      border-radius: 6px;
    }
    &::-webkit-scrollbar-track {
      background-color: transparent;
      border-radius: 6px;
    }
    // 用于缩放后截取掉不需要的空白的容器
    .pdf-box {
      overflow: hidden;
      padding: 24px;
      // border: 1px solid rgb(165, 11, 236);
    }
    // pdf预览区容器
    .pdf-scale-box {
      box-shadow: 0px 0px 20px 5px #666565;
      // border: 2px solid #090;
      // 设置缩放的中心点
      transform-origin: center top;
      transition: .2s;
    }
  }
  .bottom-tools {
    height: 50px;
    line-height: 50px;
    border-radius: 6px;
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    .page {
      color: #636a70;
      // border: 1px solid #909;
      span {
        margin-right: 20px;
      }
    }
    .scale {
      // border: 1px solid #909;
      text-align: right;
    }
  }
}
</style>
